import { InsightPanel, hasEventInsights, useFilters, usePlayerEvents } from '@statsbomb/kitbag-global-football';
import { useAtomValue } from 'jotai';
import { playerIdAtom } from '@/atoms/player/player';
import { unwrappedPlayerGamesAtom } from '@/atoms/queries/players';
import { EventInsightsCard } from '@/components/visualisations/EventInsightsCard';
import { EventInsightsEmpty } from '@/components/visualisations/EventInsightsEmpty';
import { useIsNarrowViewport } from '@/hooks/useIsNarrowViewport';
import { getSelectedEventTypes } from '@/utils/filters';

export const PlayerEventInsights = () => {
  const isNarrowViewport = useIsNarrowViewport();

  const playerId = useAtomValue(playerIdAtom);
  const games = useAtomValue(unwrappedPlayerGamesAtom);
  const [filters] = useFilters('main');

  const selectedEventTypes = getSelectedEventTypes(filters);

  const { events } = usePlayerEvents(playerId, filters, games);

  const insightPanel = <InsightPanel events={events} selectedEventTypes={selectedEventTypes} />;

  if (isNarrowViewport) {
    return hasEventInsights(selectedEventTypes) ? <EventInsightsCard>{insightPanel}</EventInsightsCard> : null;
  }

  return hasEventInsights(selectedEventTypes) ? insightPanel : <EventInsightsEmpty />;
};
